import { convertResourceToEntity } from '@vendorflow/common/lib/converters/JsonApi.converter'
import { Relationship, Resource, ResourceTypes } from '@vendorflow/types'
import { Message } from '@vendorflow/types/lib/types/Messages'
import { getRelationship } from 'services/Azimuth.service'
import { MessageWithContext } from 'types/Messages'

export function convertMessageToMessageWithContext(
  message: Resource<Message, ResourceTypes.MESSAGES>
): MessageWithContext {
  const channel = getRelationship(message.relationships!.channel as Relationship<ResourceTypes.CHANNELS>).getFirst()
  const sender = getRelationship(message.relationships!.sender as Relationship<ResourceTypes.IDENTITIES>).getFirst()
  const thread = getRelationship(message.relationships!.thread as Relationship<ResourceTypes.IDENTITIES>).getFirst()
  const broadcast = getRelationship(
    message.relationships!.broadcast as Relationship<ResourceTypes.BROADCASTS>
  ).getFirst()
  const mentions = getRelationship(message.relationships!.mentions as Relationship<ResourceTypes.IDENTITIES>).get()

  return {
    ...(convertResourceToEntity(message) as Message),
    channel: channel!.id,
    sender: sender!.id,
    thread: thread?.id,
    broadcast: broadcast?.id,
    mentions: mentions.map((m) => m.id),
  }
}
